import { EventEmitter } from 'events';

import api from '../services/reservationapi';
import schedulesStore from './schedule-store';
import jumperStore from './jumpers-store';
import swal from 'sweetalert';

// https://www.youtube.com/watch?v=bvEC6i7CUyE
class TandemData extends EventEmitter {
    constructor(){
        super();
        this.prefix = 'RESERVATION_STORE';
        this.token = '';
        this.serviceID ='';
        this.applicationProfileId ='';
        this.serviceId ='';
        this.merchantProfileId = '';
        
        this.formData={
            finalForm :{
              timeslotId:null,
              passengers:[]
            }
        };
    }

    setListeners = (socket) => {
		socket.on('makeReservation', data =>{
            this.emitResults(true,'reservationEvent');
		});
	}
    
    getTokenVal = () => {
        return this.token;
    }
    
    setTokenVal = (val) => {
        this.token = val;
    }
    
    setProcessorVals = (values) =>{
    	this.serviceID = values.ServiceID;
    	this.applicationProfileId = values.applicationProfileId;
    	this.merchantProfileId   = values.merchantProfileId;
    }
    
    getServiceId = () => {
    	return this.serviceID;
    }

    getApplicationProfileId = () => {
    	return this.applicationProfileId;
    }

    getMerchantProfileId = () => {
    	return this.merchantProfileId;
    }

    clearAll=()=>{
        
        this.formData={
            finalForm:{
              timeslotId:null,
              passengers:[]
            }
        };
    }

    getAll=()=>{
        return this.formData;
    }

    updateFormWithIndex=(formData,index)=>{
        this.formData.finalForm.passengers[index] = formData;
        this.emit('childFormUpdate',this.formData.finalForm.passengers);
    }

    updateFinalForm=(data)=>{
        data.passengers||(data.passengers=[]) // setting default
        this.formData.finalForm=data;
    }

    getFormData(index){
     return this.formData.finalForm.passengers[index]||null;
    }   

    DeleteReservation = (reservationId, refundAmount) => {
    	return new Promise((resolve, reject)=>{
    		api.cancelReservation(reservationId, refundAmount).then((r)=>{
    			if(r.status==200){
    				var result = r.data;
                    //alert('Your Reservation has been Canceled');
                    swal({
                        title: "Success",
                        text: "Reservation has been Canceled",
                        icon: "success",
                        dangerMode: false,
                    })
    			   	resolve(true);
                }
                else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
                else{
				//   this.emitError({message:'something went wrong while cancelling reservation.'});
				  resolve(false);
				}                
            })
    		.catch(err => {
    			this.emitError({message:'Incomplete or Invalid data present'});
    			reject(err);
    		});
    	});
    }
    
    ChangeReservation = (reservationBody) => {
    	return new Promise((resolve, reject) => {
    		api.changeReservation(reservationBody).then((r)=>{
    			if(r.status === 200) {
    				var result = r.data;
                    // console.log('Your Reservation has been Changed');
                    this.emitResults(r.data.datetime, 'slotChangeEvent');
    			   	resolve(true);
                }
                else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
                else { 
				  resolve(false);
				}                
            })
    		.catch(err=>{
    			this.emitError({message:'Incomplete or Invalid data present'});
    			reject(err);
    		});
    	});
    }
    
    MakeReservation = (payload) => {
        // let passangerBody = { timeslotId: payload[0].timeslotId, tandemStudents: payload[0].tandemStudents, totalPaid: payload[0].totalPaid, numVideos: payload[0].numVideos,transactionId:'Transaction123' };
        //let passangerBody = { timeslotId: payload[0].timeslotId, tandemStudents: payload[0].tandemStudents, totalPaid: 0, numVideos: payload[0].numVideos,transactionId:'Transaction123',TransactionDateTime:'Transaction_Time' };
        let passangerBody = { timeslotId: payload.slotId, students: payload.passengers, eventName: payload.eventName,
            totalCharge: parseInt(payload.amount),totalFees: parseInt(payload.totalFees), 
            numVideos: parseInt(payload.videoCount), transactionId:payload.transactionId,
            TransactionDateTime : new Date().toISOString()};
        return new Promise((resolve, reject) => {
            api.makeReservation(passangerBody).then((r) => {
                if (r.status == 200) {
                    schedulesStore.closeReservation();
                    //jumperStore.addTandemStudents(r.data.students);
                    //console.log(r);
                    this.emitResults(true,'reservationEvent');
                    resolve(r.data.reservations);
                }
                else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
                else { 
                    //console.log({ message: 'Reservation could not be created, please contact support.' });
                    this.emitResults(false,'reservationEvent');
                    this.emitResults(true, 'warningEvent');
					resolve(false);
                }
            })
            .catch((err) => {
                //console.log({ message: 'Incomplete or Invalid data present' });
                this.emitResults(false,'reservationEvent');
                reject(err);
            });
        });
    }

    VerifyGiftCard = (payload) => {
        return new Promise((resolve, reject) => {
            api.verifyGiftCard(payload).then((r) => {
                if (r.status == 200) {
                    console.log(r);
                    resolve(r.data);
                } else {
                    resolve(false);
                    console.log({ message: 'Invalid Card' });
                }
            })
            .catch((err) => {
                console.log({ message: 'Incomplete or Invalid data present' });
                reject(err);
            });
        });
    }
    
    UpdateGiftCard = (payload) => {
        return new Promise((resolve, reject) => {
            api.UpdateGiftCard(payload).then((r) => {
                if (r.status == 200) {
                    console.log(r);
                    resolve(true);
                } else {
                    resolve(false);
                    console.log({ message: 'Invalid Card' });
                }
            })
            .catch((err) => {
                console.log({ message: 'Incomplete or Invalid data present' });
                reject(err);
            });
        });
    }


    sendEmail = (body) => {
    	console.log('in load Prices email sending ');
    	return new Promise((resolve, reject)=>{
    		api.sendEmail(body).then((r)=>{
                console.log(r," email sent");
                
    		})
    		.catch(err=>{
    			reject(err);
    		});
    	});
    }



    clearState = () => {
        this.token = '';
        this.serviceID = '';
        this.applicationProfileId = '';
        this.serviceId = '';
        this.merchantProfileId = '';
    }

    emitError =(err)=> {
        var payload = {...err};
        this.emit('ERROR',payload);
    }
    
    getEventPrefix = (func) => {
        return `${this.prefix}${func}`;
    }
    
    emitResults = (r,func) => {
        //console.log(r);
        this.setMaxListeners(1000);
        this.emit(`${this.prefix}${func}`, r);
    }

    emitDate = (r,func)=> {
        this.setMaxListeners(1000);
        this.emit(`${this.prefix}${func}`,r);
    }
    
    debug=(r)=>{
        //console.log(r.data);
    } 
}

const tandemData = new TandemData();
window.tandemData = tandemData;
export default tandemData;